export const languages = [
  {
    name: "Tiếng Việt",
    icon: "vi",
    locale: "vi"
  },
  {
    name: "English",
    icon: "en",
    locale: "en"
  }
];

import en from "vee-validate/dist/locale/en";
import vi from "vee-validate/dist/locale/vi";

export const dictionaries = {
  en: en,
  vi: vi
};
